<div class="auth-full-height">
    <div class="row m-0">
        <div class="col p-0 auth-full-height" style="background-image: url('/assets/images/others/bg-1.jpg');">
            <div class="d-flex justify-content-between flex-column h-100 px-5 py-3">
                <div></div>
                <div class="w-100 ">
                    <p class="text-white lead" style="max-width: 630px;">What resides beyond this page is the list of the closest possible people who are willing to do business with you</p>
                    <h3 class="display-4 text-white mb-4">- Bijoy Patel</h3>
                </div>
                <div class="d-flex justify-content-between">
                    <span class="text-white poweredBy">© 2025 Powered by <img src="assets/images/logo/CompuBrain.svg"></span>
                    <div>
                        <a href="" class="text-white text-link me-3">Legal</a>
                        <a href="" class="text-white text-link">Privacy</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0 auth-full-height bg-white" style="max-width: 450px;">
            <div class="d-flex h-100 align-items-center p-5">
                <div class="w-100">
                    <div class="d-flex justify-content-center mt-3">
                        <logo class="text-center"></logo>
                    </div>
                    <div class="mt-4">
                        <div class="alert alert-danger" *ngIf="showResult">

                        </div>
                        <form [formGroup]="formGroup" (submit)="login()" *ngIf="!showPasswordBox">
                            <div class="form-group mb-3">
                                <label class="form-label">Email</label>
                                <input 
                                    type="text" 
                                    class="form-control no-validation-icon no-success-validation" 
                                    formControlName="email"
                                >
                            </div>
                            <button class="btn btn-primary w-100" type="submit">Forgot Password</button>
                        </form>
                        <form [formGroup]="passwordGroup" (submit)="setNewPassword()" *ngIf="showPasswordBox">
                            <div class="form-group mb-3">
                                <label class="form-label d-flex justify-content-between">
                                    <span>Password</span>
                                </label>
                                <div class="form-group input-affix flex-column">
                                    <label class="d-none">Password</label>
                                    <input 
                                        [type]="showPassword ? 'text' : 'password'" 
                                        class="form-control no-validation-icon no-success-validation" 
                                        formControlName="password"
                                    >
                                    <i 
                                        class="suffix-icon feather cursor-pointer text-dark" 
                                        [ngClass]="showPassword ? 'icon-eye-off' : 'icon-eye'" 
                                        (click)="onShowPasswordClick()"
                                    >
                                    </i>
                                </div>
                            </div>
                            <div class="form-group mb-3 ">
                                <label class="form-label d-flex justify-content-between">
                                    <span>Confirm Password</span>
                                </label>
                                <div class="form-group input-affix flex-column">
                                    <label class="d-none">Confirm Password</label>
                                    <input 
                                        type="password" 
                                        class="form-control no-validation-icon no-success-validation" 
                                        formControlName="confirmPassword"
                                    >
                                </div>
                            </div>
                            <button class="btn btn-primary w-100 mb-3 " type="submit">Submit</button>
                                    <a class="text-primary font" routerLink="/">Login  Now</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>